import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  EXCEPTION_CATEGORY_ENUM,
  IExceptionMetadata
} from '@com-delta-idp/mnx-oauth';
import {
  ApiBuilder,
  AppConfigService,
  ExceptionTrackingService,
  EXCEPTION_FILE_NAMES_ENUM,
  HttpRequestMethods
} from '@com-delta-idp/mnx-utils';
import { Observable, throwError } from 'rxjs';
import { IDP_APP } from '../../constants/login-constant';
import {
  forgotLoginRequestPayload,
  forgotLoginResponse
} from '../../models/forgot-login-interface';
import { LoginModalEndpointsKeys } from '../../models/login-modal.enum';

@Injectable({
  providedIn: 'root'
})
export class ForgotLoginContentService {
  constructor(
    private http: HttpClient,
    private appConfig: AppConfigService,
    private exceptionTrackingService: ExceptionTrackingService
  ) {}

  getForgotLoginData = (
    payload: forgotLoginRequestPayload
  ): Observable<forgotLoginResponse> =>
    new ApiBuilder<forgotLoginRequestPayload, forgotLoginResponse>(
      this.http,
      this.appConfig
    )
      .app('LOGIN_MODAL')
      .endpointKey(LoginModalEndpointsKeys['FORGOT_LOGIN_BFF_URL'])
      .method(HttpRequestMethods['POST'])
      .payload(payload)
      .errorHandler(this.handleError.bind(this))
      .create();

  handleError(error: HttpErrorResponse): Observable<never> {
    const exceptionMetadata: IExceptionMetadata = {
      fileName: EXCEPTION_FILE_NAMES_ENUM.FORGOT_LOGIN_CONTENT_SERVICE,
      methodName: '_handleError',
      exceptionCategory: EXCEPTION_CATEGORY_ENUM.API_FAILURE,
      exceptionMessage: error.error
    };
    this.exceptionTrackingService.track(
      `[${IDP_APP}]: ${error.status} : ${error.url}`,
      exceptionMetadata
    );
    return throwError(error);
  }
}
